import payload_plugin_qLmFnukI99 from "/codebuild/output/src2929202082/src/node_modules/@pinia/nuxt/dist/runtime/payload-plugin.js";
import revive_payload_client_4sVQNw7RlN from "/codebuild/output/src2929202082/src/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import path_client_2CrkUkjKpA from "/codebuild/output/src2929202082/src/plugins/path.client.ts";
import unhead_KgADcZ0jPj from "/codebuild/output/src2929202082/src/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/codebuild/output/src2929202082/src/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "/codebuild/output/src2929202082/src/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_bs2bWDGRIE from "/codebuild/output/src2929202082/src/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/codebuild/output/src2929202082/src/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import chunk_reload_client_UciE0i6zes from "/codebuild/output/src2929202082/src/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import plugin_vue3_YdLad5Mpq3 from "/codebuild/output/src2929202082/src/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.js";
import components_plugin_KR1HBZs4kY from "/codebuild/output/src2929202082/src/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/codebuild/output/src2929202082/src/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import plugin_tbFNToZNim from "/codebuild/output/src2929202082/src/node_modules/@zadigetvoltaire/nuxt-gtm/dist/runtime/plugin.mjs";
import plugin_client_UYiXMU8ZyN from "/codebuild/output/src2929202082/src/node_modules/nuxt-gtag/dist/runtime/plugin.client.js";
import toaster_075gpxZKPU from "/codebuild/output/src2929202082/src/node_modules/maz-ui/nuxt/runtime/plugins/toaster.js";
import plugin_TzdokXk5of from "/codebuild/output/src2929202082/src/node_modules/nuxt-permissions/dist/runtime/plugin.mjs";
import switch_locale_path_ssr_5csfIgkrBP from "/codebuild/output/src2929202082/src/node_modules/@nuxtjs/i18n/dist/runtime/plugins/switch-locale-path-ssr.js";
import i18n_sq1MuCrqbC from "/codebuild/output/src2929202082/src/node_modules/@nuxtjs/i18n/dist/runtime/plugins/i18n.js";
import plugin_Jozdw60ZsE from "/codebuild/output/src2929202082/src/node_modules/dayjs-nuxt/dist/runtime/plugin.js";
import components_client_ZB1W0EeH0E from "/codebuild/output/src2929202082/src/node_modules/nuxt-swiper/dist/runtime/plugins/components.client.js";
import MazPhoneNumber_client_GXkA3Xktsj from "/codebuild/output/src2929202082/src/plugins/MazPhoneNumber.client.ts";
import event_bus_S6Iq1iGe5d from "/codebuild/output/src2929202082/src/plugins/event-bus.ts";
import socket_utils_client_4mgkQH40w3 from "/codebuild/output/src2929202082/src/plugins/socket-utils.client.ts";
import vfm_AT9bKzcFx9 from "/codebuild/output/src2929202082/src/plugins/vfm.ts";
import vue_lazily_OlRAiOs9f0 from "/codebuild/output/src2929202082/src/plugins/vue-lazily.ts";
export default [
  payload_plugin_qLmFnukI99,
  revive_payload_client_4sVQNw7RlN,
  path_client_2CrkUkjKpA,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  navigation_repaint_client_bs2bWDGRIE,
  check_outdated_build_client_8vK7RkfGxZ,
  chunk_reload_client_UciE0i6zes,
  plugin_vue3_YdLad5Mpq3,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  plugin_tbFNToZNim,
  plugin_client_UYiXMU8ZyN,
  toaster_075gpxZKPU,
  plugin_TzdokXk5of,
  switch_locale_path_ssr_5csfIgkrBP,
  i18n_sq1MuCrqbC,
  plugin_Jozdw60ZsE,
  components_client_ZB1W0EeH0E,
  MazPhoneNumber_client_GXkA3Xktsj,
  event_bus_S6Iq1iGe5d,
  socket_utils_client_4mgkQH40w3,
  vfm_AT9bKzcFx9,
  vue_lazily_OlRAiOs9f0
]